/*=========================================================================================
  File Name: moduleTheoryRatingManagement.js
  Description: Receipt Module
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Sib
  Author URL: http://www.organix-it.com
==========================================================================================*/

import state from './moduleTheoryRatingManagementState.js'
import mutations from './moduleTheoryRatingManagementMutations.js'
import actions from './moduleTheoryRatingManagementActions.js'
import getters from './moduleTheoryRatingManagementGetters.js'

export default {
  isRegistered: false,
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
}